import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { timeAgo } from "@/lib/api";

export default function HeroCard({ article }) {
  if (!article) {
    return (
      <div className="w-full h-[400px] bg-[color:var(--surface-2)] animate-pulse rounded-sm" />
    );
  }
  return (
    <article
      className="relative grid grid-cols-1 lg:grid-cols-12 overflow-hidden rounded-sm grain"
      style={{ background: "var(--hero-bg)", color: "white", minHeight: 320 }}
      data-testid="hero-card"
    >
      <div className="order-2 lg:order-1 lg:col-span-5 p-5 md:p-8 lg:p-10 flex flex-col justify-between gap-5 md:gap-6 z-10 relative">
        <div className="flex items-center gap-3 overline accent-text">
          <span>{article.category_slug?.toUpperCase()}</span>
          <span className="text-white/40">·</span>
          <span className="text-white/60">{timeAgo(article.published_at)}</span>
        </div>
        <h1
          className="font-headline uppercase text-2xl sm:text-3xl md:text-4xl lg:text-[40px] leading-[0.98] tracking-tight"
          data-testid="hero-title"
        >
          {article.title}
        </h1>
        <div className="space-y-4 md:space-y-5">
          <p className="text-sm text-white/70 max-w-md leading-relaxed line-clamp-3">
            {article.bajada}
          </p>
          <Link
            to={`/nota/${article.slug}`}
            data-testid="hero-read-button"
            className="btn-accent"
          >
            LEER NOTA COMPLETA <ArrowRight size={16} />
          </Link>
        </div>
      </div>
      <div className="order-1 lg:order-2 lg:col-span-7 relative min-h-[200px] sm:min-h-[260px] lg:min-h-full">
        {article.featured_image && (
          <img
            src={article.featured_image}
            alt={article.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, transparent 40%, var(--hero-bg) 100%), linear-gradient(90deg, var(--hero-bg) 0%, rgba(10,10,10,0.0) 35%, transparent 100%)",
          }}
        />
      </div>
    </article>
  );
}
